import { useContext } from 'react';

import CancelContext from '../context/CancelProvider';

const useCancel = () => {

  return useContext(CancelContext);
}

export default useCancel;